import styled from "styled-components";
import Layout from "../../../components/custom/Layout";
import useData from "./useData";
import VirtualTable from "../../../components/custom/VirtualTable";
import { CronJob, CronJobEmail } from "../../../globals/interfaces";
import ActionIcon from "../../../components/custom/ActionIcon";
import ModalAddEmail from "./ModalAddEmail";
import useModal from "../../../customHooks/useModal";
import { notify } from "../../../utils";
import ModalUpdateCronJob from "./ModalUpdateCronJob";

export default function AutomatedEmailAlerts() {

    const {
        jobs,
        refreshJobs,
        emails,
        cronJobId,
        setCronJobId,
        selectedJob,
        addEmail,
        deleteEmail,
        updateCronJob
    } = useData();

    const handleDeleteEmail = async (cronJobEmail: CronJobEmail) => {
        await deleteEmail(cronJobEmail);
        notify('Email deleted');
    }

    const { modal, setModal } = useModal();
    const { modal: modalUpdateJob, setModal: setModalUpdateJob } = useModal();

    return (
        <Layout>
            <Container>
                <div>
                    <h6>Automated Email Alerts</h6>
                    <VirtualTable<CronJob>
                        data={jobs}
                        mapping={[{
                            name: 'Name',
                            value: 'displayName'
                        }, {
                            name: '',
                            value: 'fas fa-edit',
                            icon: true,
                            function: () => setModalUpdateJob(true)
                        }]}
                        numRows={10}
                        handleClick={item => setCronJobId(item.cronJobId)}
                    />
                </div>
                <Details>
                    {
                        selectedJob && (
                            <div>
                                <h6>{selectedJob.displayName}</h6>
                                <div>{selectedJob.description}</div>
                                <FlexContainer>
                                    <h6>Emails:</h6>
                                    <ActionIcon
                                        type={'add'}
                                        onClick={() => setModal(true)}
                                    />
                                </FlexContainer>
                                <VirtualTable<CronJobEmail>
                                    data={emails}
                                    mapping={[{
                                        name: 'Email',
                                        value: 'email'
                                    }, {
                                        name: 'Created by',
                                        value: 'createdBy',
                                        email: true
                                    }, {
                                        name: 'Created',
                                        value: 'createdDate',
                                        datetime: true,
                                        utc: true
                                    }, {
                                        name: '',
                                        value: 'cronJobEmailId',
                                        delete: true,
                                        function: item => handleDeleteEmail(item)
                                    }]}
                                    numRows={10}
                                />
                            </div>
                        )
                    }
                </Details>
            </Container>
            <ModalAddEmail
                modal={modal}
                setModal={setModal}
                selectedJob={selectedJob}
                addEmail={addEmail}
            />
            <ModalUpdateCronJob
                modal={modalUpdateJob}
                setModal={setModalUpdateJob}
                selectedJob={selectedJob}
                updateCronJob={updateCronJob}
            />
        </Layout>
    );
}

const Container = styled.div`
    display: flex;
    gap: 10px;
`;

const Details = styled.div`
    flex: 3;
`;

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
